import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule} from '@angular/common';
import { ProductListComponent} from './product-list/product-list.component';
import { ProductRoutingModule} from './products-routing.module';
import { NgbDatepickerModule, NgbNavModule, NgbPaginationModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';

import { featuresReducers} from '../app.state';
import { StoreModule} from '@ngrx/store';
import { EffectsModule} from '@ngrx/effects';
import { ProductsEffects} from './state/product-list/list-effects';
import { PRODUCT_FEATURE} from '../app.state';
import { SharedModule} from '../shared/shared.module';
import { ProductTab1Component} from './product-tab1/product-tab1.component';
import { ProductTab2Component} from './product-tab2/product-tab2.component';
import { NgxSkeletonLoaderModule} from 'ngx-skeleton-loader';
import { ProductDetailsComponent} from './product-details/product-details.component';
import { ProductsDetailsEffects} from './state/product-details/details-effects';
import { RelatedProductsEffects} from './state/related-product/related-effects';
import { NgxSliderModule } from '@angular-slider/ngx-slider';

import { ShoppingCartComponent } from './shopping-cart/shopping-cart.component';
import { ClearCartComponent } from './shopping-cart/actions/clear-cart.component';
import { ProductCategoryComponent} from '@app/marketplace/products/product-category/product-category.component';
import { CrystalLightboxModule } from '@crystalui/angular-lightbox';
import { SelectLocationComponent} from '@app/marketplace/locations/select-location/select-location.component';
import { TreeviewModule } from 'ngx-treeview';
import { ProductDimensionsComponent } from './product-dimensions/product-dimensions.component';
import { ProductShippingComponent } from './product-shipping/product-shipping.component';
import { ShoppingShippingComponent } from './shopping-shipping/shopping-shipping.component';
import { ReactiveFormsModule} from '@angular/forms';
import { ProductFakeDetailsComponent } from './product-fake-details/product-fake-details.component';
import { ProductAttributesComponent } from './product-attributes/product-attributes.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ProductDetailsDlgComponent } from './product-details-dlg/product-details-dlg.component';
import { RelatedProductsComponent } from './related-products/related-products.component';

@NgModule({
  declarations: [
    ProductListComponent,
    ProductTab1Component,
    ProductTab2Component,
    ProductDetailsComponent,
    ProductDetailsDlgComponent,
    ProductFakeDetailsComponent,
    ProductCategoryComponent,
    ShoppingCartComponent,
    ClearCartComponent,
    SelectLocationComponent,
    ProductDimensionsComponent,
    ProductShippingComponent,
    ShoppingShippingComponent,
    ProductAttributesComponent,
    RelatedProductsComponent
  ],
    imports: [
        CommonModule,
        ProductRoutingModule,
        NgbDatepickerModule,
        NgbNavModule,
        NgbTooltipModule,
        NgbPaginationModule,
        StoreModule.forFeature(PRODUCT_FEATURE.stateKey, featuresReducers),
        EffectsModule.forFeature([ProductsEffects,ProductsDetailsEffects,RelatedProductsEffects]),
        NgxSkeletonLoaderModule.forRoot({animation: 'pulse'}),
        SharedModule,
        NgxSliderModule,
        TreeviewModule.forRoot(),
        CrystalLightboxModule,
        ReactiveFormsModule,
        InfiniteScrollModule
    ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ProductsModule {
}
